export default __webpack_public_path__ + "static/media/priority.97d6cbcf.png";